import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, Loading } from "@/components/ui-kit";
import { ListChecks, PenLine, Clock, CheckCircle2, ArrowRight } from "lucide-react";
import { fmtDue } from "@/lib/due";

export default function StudentHomework() {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/homework").then((r) => setRows(r.data)); }, []);
  if (!rows) return <Loading />;

  const go = (h) => {
    const writing = h.questions?.[0]?.type === "writing";
    navigate(writing ? `/student/writing/${h.id}` : `/student/exam/${h.id}`);
  };

  return (
    <div className="animate-fade-up">
      <PageHeader title="This Week" subtitle="All homework released to you." />
      <div className="grid gap-3">
        {rows.length === 0 && <div className="ember-card py-16 text-center text-sm text-[#948EAB]">No homework released yet.</div>}
        {rows.map((h) => {
          const writing = h.questions?.[0]?.type === "writing";
          return (
            <button key={h.id} onClick={() => go(h)} data-testid={`sh-tile-${h.id}`} className="ember-card ember-card-hover flex items-center gap-4 p-5 text-left">
              <span className={`grid h-11 w-11 place-items-center rounded-xl ${writing ? "bg-[#FFF1F2] text-[#E11D48]" : "bg-[#EDE9FE] text-[#5B21B6]"}`}>{writing ? <PenLine className="h-5 w-5" /> : <ListChecks className="h-5 w-5" />}</span>
              <div className="min-w-0 flex-1">
                <div className="truncate font-heading font-bold text-[#1E1B2E]">{h.title}</div>
                <div className="mt-0.5 flex flex-wrap gap-x-3 text-xs text-[#948EAB]">
                  <span>{h.section_name}</span>{h.due_date && <span>{fmtDue(h.due_date)}</span>}
                  <span>{writing ? "Written task" : `${h.question_count} questions`}</span>
                  <span className="inline-flex items-center gap-1"><Clock className="h-3 w-3" /> {h.mode === "timed" ? `${h.time_limit}m` : "Practice"}</span>
                </div>
              </div>
              {h.student_status === "completed"
                ? (h.results_released
                    ? <span className="inline-flex items-center gap-1 rounded-full bg-[#ECFDF5] px-2.5 py-1 text-xs font-bold text-[#059669]"><CheckCircle2 className="h-3.5 w-3.5" /> {h.score != null ? `${Math.round(h.score)}%` : "Done"}</span>
                    : <span className="inline-flex items-center gap-1 rounded-full bg-[#FFFBEB] px-2.5 py-1 text-xs font-bold text-[#B45309]"><Clock className="h-3.5 w-3.5" /> Being marked</span>)
                : <ArrowRight className="h-5 w-5 text-[#C4B5FD]" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
